<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
	{{ data.message }}
</div>
